export interface IFile {
  name: string;
  path: string;
  id: string;
  // uid?: string;
  pipeFrom: string;
  thumbnailPipeFrom?: string;
  details: Record<string, any>;
  size?: number;
  type?: string;
  extension?: string;
}
export enum DocumentSubType {
  COMMON = 'COMMON',
  SHIPPING_LABEL = 'SHIPPING_LABEL',
  SCANNED = 'SCANNED',
}

export interface IDocument<T = IFile> {
  id: string;
  details: Record<string, any>;
  subType: DocumentSubType;
  files: T[];
  user?: string;
}
